<template>
  <FavouriteIcon class="signals-bookmark" :class="isBookmarked ? 'signals-bookmark--active' : ''" @click="toggle()" data-lock-click />
</template>

<script setup>
  import { Props } from './props.js';
  import { useStore } from 'vuex';
  import { computed } from 'vue';
  //-------------------------------
  import FavouriteIcon from '@/Groups/Signals/private/svg/FavouriteIcon.vue';
  //-------------------------------
  const props = defineProps(Props());
  const store = useStore();
  //-------------------------------
  const isBookmarked = computed(() => {
    const signal = store.getters["Signals/data"][props.id];
    return signal?.reactions?.bookmarked?.is_mine ?? false;
  });
  //-------------------------------
  const toggle = () => {
    store.dispatch("Signals/toggleFavouriteOptimistic", props.id);
  }
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>